// extracted by mini-css-extract-plugin
export const reactCalendarTile = "calendar-module--reactCalendarTile--1wBxN";
export const reactCalendar = "calendar-module--reactCalendar--3Id4z";